<template>
  <q-btn small flat color="iconColor">
      <q-icon :name="booleanIcon" :color="iconColor"></q-icon>
  </q-btn>
</template>
<script>
export default {
  name: 'grid-cell-image',
  props: {
    column: {
      required: true,
      type: Object
    },
    value: {
      default: () => false
    }
  },
  computed: {
    booleanIcon () {
      return this.value === 1 || this.value ? 'check' : 'close'
    },
    iconColor () {
      return this.value === 1 || this.value ? 'positive' : 'grey-4'
    }
  }
}
</script>
